// extracted by css-extract-rspack-plugin
export default {"cls1":"SelectionCitation-cls1_P7q","cls2":"SelectionCitation-cls2_Ign SelectionCitation-cls1_P7q"};